//
// Copyright (c) 2011-2024 by Curalate, Inc
//

import { IContentLibraryItem } from '@apis/content-library/contentLibraryApiModel';
import { isDefined } from '@utils/filterPredicates';

export const isVideo = (item: IContentLibraryItem): boolean => {
  return isDefined(item.metadata.videoSource);
};

export const isVideoProcessing = (item: IContentLibraryItem): boolean => {
  return isVideo(item) && item.videoStatus === 'Processing';
};

export const isImage = (item: IContentLibraryItem): boolean => {
  return !isVideo(item);
};

export const isGif = (item: IContentLibraryItem): boolean => {
  const contentType = item.metadata.contentType;

  if (contentType) {
    return contentType === 'image/gif';
  }

  const numFrames = item.metadata.numFrames ?? 1;
  const isVideoItem = isVideo(item); // Ignore videos with GIF thumbnails

  return !isVideoItem && numFrames > 1;
};
